import { Review } from "@core/domain/models/review.model";
import { HtaMetadata } from "@core/domain/models/reviewItemMetadata/htaMetadata";
import { BuiltInImportSourceId } from "@core/domain/types/builtInImportSourceId";
import { ReviewItemType } from "@core/domain/types/reviewItemType.type";
import axios from "axios";

export class HtaApiClient {
  async createReviewSearch(
    review: Review,
    query: string,
    startYear?: string,
    endYear?: string,
  ): Promise<{
    query?: string;
    filters?: string;
    date: string;
    reviewId: number;
    importSourceId: string;
    items: HtaMetadata & { type: ReviewItemType.Hta }[];
    queryTranslation?: string;
    url?: string;
  }> {
    const results = await this.search(query, startYear, endYear);
    let url = `https://database.inahta.org/search?limit=&terms=${encodeURIComponent(query)}&client=user`;

    if (startYear) {
      url += `&filter-year-from=${startYear}`;
    }
    if (endYear) {
      url += `&filter-year-to=${endYear}`;
    }

    return {
      query,
      date: new Date().toISOString(),
      reviewId: review.id,
      importSourceId: BuiltInImportSourceId.HTA_DATABASE,
      items: results.map((item) => ({
        ...item,
        type: ReviewItemType.Hta,
      })),
      url,
    };
  }

  async search(query: string, startYear?: string, endYear?: string): Promise<HtaMetadata[]> {
    return this.searchHtas(query, startYear, endYear);
  }

  private async searchHtas(
    query: string,
    startYear?: string,
    endYear?: string,
  ): Promise<HtaMetadata[]> {
    let htas: HtaMetadata[] = [];
    const url = "/live-scraper/hta";
    try {
      let fullQuery = query;

      if (startYear && endYear) {
        fullQuery += ` FROM ${startYear} TO ${endYear}`;
      } else if (startYear) {
        fullQuery += ` FROM ${startYear} TO ${new Date().getFullYear()}`;
      } else if (endYear) {
        fullQuery += ` FROM ${endYear} TO ${endYear}`;
      }

      const response = await axios.post(url + `?query=${encodeURIComponent(fullQuery)}`);
      htas = response.data.map(
        (item: any) =>
          new HtaMetadata({
            title: item.title,
            abstract: item.abstract,
            authors: Array.isArray(item.authors) ? item.authors : [item.authors],
            doi: item.doi,
            publishYear: item.publishYear,
            potentialPdfUrl: item.url,
            issueNumber: item.issueNumber,
            journal: item.journal,
            pagesNumber: item.pagesNumber,
          }),
      );
    } catch (error) {
      console.error("Error fetching records from HTA API:", error);
      throw error;
    }

    return htas;
  }
}
